import styles from '../../assets/styles/Settings/Settings.module.scss';
import { AppPage, IconButton, MimaText, MimaToastUtil } from '../../components';
import React, { useState } from 'react';
import { businessStore } from '../../stores';
import { MdOutlineContentCopy } from 'react-icons/md';

const ApiKeys = () => {
	const { business } = businessStore;

	const [hide, setHide] = useState(true);

	let eye;
	!hide ? (eye = 'eyeOpen') : (eye = 'eyeClose');

	const keyToggle = () => {
		setHide(!hide);
	};

	const pluginUrl =
		'https://drive.google.com/file/d/1j0EKkqD82xNdVd3-9p4PWjdGk71f-q4N/view?usp=drive_link';
	const downloadPlugin = () => {
		window.open(pluginUrl, '_blank');
	};
	return (
		<AppPage pageTitle="API Keys">
			<div className={styles.developers}>
				<div className={styles.ai}>
					<MimaText variant="subtitleBold">
						How to Install the Mimapay plugin on your website
					</MimaText>
					<MimaText>
						1. Click{' '}
						<span className={styles.ai__link} onClick={downloadPlugin}>
							HERE
						</span>{' '}
						to download the MimaPay WooCommerce Payment Gateway
					</MimaText>
					<MimaText>
						2. Go to WordPress Admin - Plugins - Upload Plugin from the
						left-hand menu
					</MimaText>
					<MimaText>3. Click on Install now to install the plugin</MimaText>
					<MimaText>4. After installation, activate the plugin.</MimaText>
					<MimaText>4. After installation, activate the plugin.</MimaText>
				</div>
				<div className={styles.ai}>
					<div className={styles.ai__card}>
						<div className={styles.ai__card__align}>
							<MimaText labelTitle="Live Secret Key">
								<span className={styles.ai__key}>
									{!hide ? business.secretKey : '*******'}
								</span>
							</MimaText>
							<IconButton onClick={() => keyToggle()} variant={eye} />
						</div>
						<div
							onClick={() => {
								navigator.clipboard.writeText(
									business ? business.secretKey : ''
								);
								MimaToastUtil.success({
									message: 'Copied!',
								});
							}}
							className={styles.ai__copy}>
							<MdOutlineContentCopy />
							<MimaText variant="smallBold" color="var(--color-white)">
								Click to copy Key
							</MimaText>
						</div>
					</div>
					<div className={styles.ai__card}>
						<MimaText labelTitle="Live Public Key">
							<span className={styles.ai__key}>{business.publicKey}</span>
						</MimaText>
						<div
							onClick={() => {
								navigator.clipboard.writeText(
									business ? business.publicKey : ''
								);
								MimaToastUtil.success({
									message: 'Copied!',
								});
							}}
							className={styles.ai__copy}>
							<MdOutlineContentCopy />
							<MimaText variant="smallBold" color="var(--color-white)">
								Click to copy Key
							</MimaText>
						</div>
					</div>
				</div>
				<div className={styles.ai}>
					<MimaText variant="subtitleBold">
						How to Activate the Mimapay plugin on your WordPress website
					</MimaText>
					<MimaText>
						1. Go to WooCommerce - Settings and click on the Payments tab
					</MimaText>
					<MimaText>
						2. You'll see MimaPay listed along with your other payment methods.
						Click Set Up
					</MimaText>
					<MimaText>
						3. On the next screen, configure the plugin. There is a selection of
						options on the screen. Read what each one does below.
					</MimaText>
					<MimaText>
						4. <b>Enable/Disable </b> - Check this checkbox to Enable MimaPay on
						your store's checkout
					</MimaText>
					<MimaText>
						5. <b>Test Mode</b> - Check this to enable test mode. When selected,
						the fields in step six will say <b>"Test"</b> instead of{' '}
						<b>"Live"</b>. Test mode enables you to test payments before going
						live. <br /> <br />
						The orders process with test payment methods, no money is involved
						so there is no risk. You can uncheck this when your store is ready
						to accept real payments.
					</MimaText>
					<MimaText>
						6. <b>API Keys </b> - The next two text boxes are for your MimaPay
						API keys, which you can get from your below. If you enabled Test
						Mode in step two, then you'll need to use your test API keys here.
						Otherwise, you can enter your live keys.
					</MimaText>
					<MimaText>7. Click on Save Changes to update the settings.</MimaText>
				</div>
			</div>
		</AppPage>
	);
};

export default ApiKeys;
